import { type AnyAction, combineReducers } from 'redux';

import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';
import {
    clearLuminaryThumbnail,
    storeLuminaryThumbnail,
} from 'js/src/data/thumbnail-previews/thumbnail-previews-actions';
import type { LuminaryThumbnail } from 'js/src/data/thumbnail-previews/thumbnail-previews-types';

export function luminaryThumbnails(
    state = PlainJsStoreORM.createEmpty<LuminaryThumbnail, string | number>().data,
    action: AnyAction,
) {
    if (storeLuminaryThumbnail.match(action)) {
        const orm = new PlainJsStoreORM<LuminaryThumbnail, string | number>(state);
        orm.pushItem({ id: action.payload.id, previewCanvas: action.payload.image }, 'id');
        return orm.data;
    }

    if (clearLuminaryThumbnail.match(action)) {
        const orm = new PlainJsStoreORM<LuminaryThumbnail, string | number>(state);
        orm.delete([action.payload.id]);
        return orm.data;
    }

    return state;
}

export const thumbnailPreviews = combineReducers({
    luminaryThumbnails,
});

export type ThumbnailPreviewsState = ReturnType<typeof thumbnailPreviews>;
